<template>
  <div class="caution l-inner">
    <div class="caution__section">
      <div class="caution__title">【応募規定・禁止事項】</div>
      <ul class="caution__section__inner">
        <li class="caution__section__item">
          <div class="caution__item__title">■応募規定</div>
          <ul clas="m-list">
            <li class="m-list__item">
              ・Groupe PSA Japan株式会社（以下
              「当社」といいます）、シトロエン販売店関係者やその家族は除く
            </li>
            <li class="m-list__item">
              ・賞品の当選権利を他人に譲渡することはできません。
            </li>
            <li class="m-list__item">・賞品の発送は日本国内のみとなります。</li>
            <li class="m-list__item">
              ・本キャンペーンの応募にかかるインターネット接続料及び通信費は応募者のご負担となります。
            </li>
            <li class="m-list__item">
              ・応募期間中に、この規約に同意され、ご応募いただいた方。
            </li>
          </ul>
        </li>
        <li class="caution__section__item">
          <div class="caution__item__title">■禁止事項</div>
          <p>本キャンペーンへの応募に際し 、以下行為を禁止します。</p>
          <span>応募規約に違反する行為</span>
          <ul class="m-list">
            <li class="m-list__item">・本キャンペーンの運営を妨げる行為</li>
            <li class="m-list__item">
              ・他人に迷惑、不利益、損害または不快感を与える行為
            </li>
            <li class="m-list__item">
              ・他人を誹謗中傷し、またはその名誉もしくは信用を毀損する行為
            </li>
            <li class="m-list__item">
              ・他人の著作権その他の知的財産権を損害する行為
            </li>
            <li class="m-list__item">
              ・他人の財産、プライバシーもしくは肖像権を侵害する行為
            </li>
            <li class="m-list__item">
              ・当社が本キャンペーンの趣旨に沿わないと判断する行為
            </li>
            <li class="m-list__item">
              ・当社が悪質または不適切であると判断する行為
            </li>
            <li class="m-list__item">
              ・わいせつ、児童ポルノおよび児童の性的搾取を助長するデータを投稿する行為
            </li>
            <li class="m-list__item">
              ・営利を目的とした情報提供、広告宣伝もしくは勧誘行為
            </li>
            <li class="m-list__item">・公序良俗に反する行為</li>
            <li class="m-list__item">・その他、前各号に類する行為</li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="caution__section">
      <div class="caution__title">【免責事項】</div>
      <div class="caution__section__inner">
        <p class="m-paragraph">
          本キャンペーンは、細心の注意を払って運営していますが、提供する情報、プログラム、各種サービス、その他本キャンペーンに関するすべての事項について、その完全性、正確性、安全性、有用性等について、いかなる保証をするものではありません。<br />また、利用者又は第三者が被った以下の事例を含む損害については、当社は責任を負いかねます。
        </p>
        <p class="m-paragraph">
          当社は、禁止事項に抵触していると判断た投稿写真の非掲載・掲載後削除等対応をとる場合があります。<br />本キャンペーンの応募に際して、ソフトウェア・ハードウェア上の事故、火災、停電、通信環境の悪化、地震、事変等の非常事態が発生した場合。
        </p>
        <p class="m-paragraph">
          本キャンペーンにおけるシステムの保守を定期的あるいは緊急に行う場合。<br />
          利用者間または利用者と第三者の間におけるトラブル等が生じた場合。<br />
          第三者による本キャンペーンのサービスの妨害、情報改変などによりサービスが中断もしくは遅延し、何らかの欠損が生じた場合。<br />
          故意または重過失なくして本キャンペーンが提供する情報が誤送信されるか、もしくは欠陥があった場合。
        </p>
      </div>
    </div>
    <div class="caution__section">
      <div class="caution__title">【個人情報の取り扱いについて】</div>
      <div class="caution__section__inner">
        <p class="m-paragraph">
          本キャンペーンでGroupe PSA Japan株式会社（以下
          「当社」といいます）が取得する個人情報は、キャンペーン当選商品の送付、<br />
          またはそれに付随する業務にのみ利用し、それ以外の目的では利用いたしません。<br />
          当社の個人情報保護に関する基本方針はプライバシーポリシーに明記しています。<br />
          <a
            href="https://www.citroen.jp/privacy_policy/"
            class="caution__textlink"
            target="_blank"
            >https://www.citroen.jp/privacy_policy/</a
          >
        </p>
        <div class="caution__section__item">
          <div class="caution__item__title">
            ■キャンペーンに関するお問い合わせ窓口
          </div>
          <p class="m-paragraph">
            本キャンペーンについてのお問い合わせは、下記シトロエンコールにお電話くださいますよう、お願いいたします。<br />
            シトロエン コール<br />
            0120-55-4106<br />
            受付時間<span class="caution__time">9:00～19:00（年中無休）</span>
          </p>
        </div>
      </div>
    </div>
    <div class="caution__section">
      <div class="caution__title">【応募写真・投稿コメントの利用に関して】</div>
      <div class="caution__inner">
        <p class="m-paragraph">
          写真付きの投稿で応募するキャンペーンにおいて、応募者は当社に対し、以下における利用に関し、応募写真・投稿コメントについての全世界にわたる無償の利用権（応募写真を複製、表示、掲載、公表、展示、頒布、上映、公衆送信、翻案等する権利）を許諾したものとします。
        </p>
        <ol class="m-paragraph">
          <li class="m-list__item">
            1.
            当社等が主催するキャンペーン（本キャンペーンを含む）の掲載・結果発表・告知等
          </li>
          <li class="m-list__item">
            2.
            当社等が管理、使用、主催、参加または発行するウェブサイト、公式SNSアカウント、イベント・展示会（その施設等を含みます）、印刷物、販売促進物、宣伝広告物等
          </li>
          <li class="m-list__item">
            3. その他当社等が実施するマーケティング等
          </li>
        </ol>
        <ul class="m-paragraph">
          <li class="m-list__item">
            ・当社等は、応募写真を改変等して利用することがあります。また、当社等は、応募者のお名前・投稿コメント等を表示、省略表示または表示しないで利用することがあります。これらの場合、応募者は、当社等に対し、著作者人格権に基づく権利主張は行なわないものとします。
          </li>
          <li class="m-list__item">
            ・被写体の人物への肖像権侵害等の責任は負いかねます。万一、第三者と紛争等が生じた場合は、すべて応募者の責任とします。
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "caution-page",
};
</script>
<style lang="scss">
.m-paragraph {
  & + & {
    margin-top: 1em;
  }
}
.caution {
  max-width: 980px;
  width: 100%;
  margin-top: 50px;
  margin-bottom: 50px;
  &__section {
    & + & {
      margin-top: 30px;
    }
    &__inner {
      margin-top: 10px;
    }
    &__item {
      margin-top: 15px;
    }
  }
  &__title {
    font-size: 18px;
  }
  &__item {
    &__title {
    }
  }
  &__textlink {
    text-decoration: underline;
  }
  &__time {
    margin-left: 1em;
  }
}
</style>
